export const UNSELECTED_INDEX = -1;
export const isIdSelected = (id: number) => (id != null) && (id !== UNSELECTED_INDEX);